import { defineMessages } from 'react-intl'

const messages = defineMessages({
  title: {
    id: 'global.checkin-important-information',
  },
  checkIn: {
    id: 'search.checkin',
  },
  checkOut: {
    id: 'search.checkout',
  },
  checkInTime: {
    id: 'global.checkin-time',
  },
  checkOutTime: {
    id: 'global.checkout-time',
  },
  showMore: {
    id: 'global.show-more',
  },
  showLess: {
    id: 'global.show-less',
  },
  instructions: {
    id: 'global.instructions',
  },
  specialInstructions: {
    id: 'global.special-instructions',
  },
  fees: {
    id: 'global.fees',
  },
  policies: {
    id: 'global.policies',
  },
  additionalInformation: {
    id: 'global.additional-information',
  },
  minAge: {
    id: 'global.minimum-checkin-age',
  },
})

export default messages
